//@ts-nocheck
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var go = function () { return __awaiter(void 0, void 0, void 0, function () {
    var checkGoogleAuth, googleUserInfo, googleUserId, googleAppId, authMethodId, isAuthorized;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                checkGoogleAuth = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var resp, jsonResp, keys, decoded, header, kid, key, subtleImportedKey, publicKey, body, pemKey, payload;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                console.log('Downloading google keys');
                                return [4 /*yield*/, fetch('https://www.googleapis.com/oauth2/v3/certs')];
                            case 1:
                                resp = _a.sent();
                                return [4 /*yield*/, resp.json()];
                            case 2:
                                jsonResp = _a.sent();
                                console.log('Google keys downloaded: ', jsonResp);
                                keys = jsonResp.keys;
                                decoded = jwt.decode(googleToken, { complete: true });
                                header = decoded.header;
                                kid = header.kid;
                                console.log('JWT parsed');
                                key = keys.find(function (k) { return k.kid === kid; });
                                console.log('Found key: ', key);
                                // convert the key so it can be used by the JWT library
                                delete key.alg;
                                return [4 /*yield*/, crypto.subtle.importKey('jwk', key, { name: 'RSASSA-PKCS1-v1_5', hash: 'SHA-256' }, true, ['verify'])];
                            case 3:
                                subtleImportedKey = _a.sent();
                                return [4 /*yield*/, crypto.subtle.exportKey('spki', subtleImportedKey)];
                            case 4:
                                publicKey = _a.sent();
                                body = btoa(String.fromCharCode.apply(String, new Uint8Array(publicKey)));
                                body = body.match(/.{1,64}/g).join('\\n');
                                pemKey = '-----BEGIN PUBLIC KEY-----\\n' + body + '\\n-----END PUBLIC KEY-----';
                                console.log('Key converted');
                                payload = jwt.verify(googleToken, pemKey, { algorithms: ['RS256'] });
                                console.log('JWT verified');
                                return [2 /*return*/, payload];
                        }
                    });
                }); };
                return [4 /*yield*/, checkGoogleAuth()];
            case 1:
                googleUserInfo = _a.sent();
                console.log('Google user info: ', googleUserInfo);
                googleUserId = googleUserInfo.sub;
                googleAppId = googleUserInfo.aud;
                console.log('Google user id: ', googleUserId, 'Google app id: ', googleAppId);
                authMethodId = ethers.utils.arrayify(ethers.utils.keccak256(ethers.utils.toUtf8Bytes(googleUserId + ':' + googleAppId)));
                console.log('authMethodId: ', authMethodId);
                console.log('pkpTokenId: ', pkpTokenId);
                return [4 /*yield*/, Lit.Actions.isPermittedAuthMethod({
                        tokenId: pkpTokenId,
                        authMethodType: '6',
                        userId: authMethodId,
                    })];
            case 2:
                isAuthorized = _a.sent();
                console.log('Is authorized: ', isAuthorized);
                if (!isAuthorized) {
                    Lit.Actions.setResponse({ response: 'Unauthorized' });
                    return [2 /*return*/];
                }
                Lit.Actions.signEcdsa({ publicKey: pkpPublicKey, toSign: toSign, sigName: 'sig1' });
                return [2 /*return*/];
        }
    });
}); };
export var GOOGLE_AUTH_ACTION = 'const go = ' + go.toString() + ';' + ' go();';
